import React, { useEffect } from "react";
import { connect } from "react-redux";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../shared/loader";
import {
    fetchBackgroundActorOverview,
    updateBackgroundActorSignedRelease
} from "./ducks/actions";
import Onboarding from '../../../shared/onboarding/onboarding';
import Overview from "./overview";
import './actor-overview.scss'

const OverviewContainer = (props) => {
    const filmId = props.match.params.filmId;
    const {
        fetchBackgroundActorOverview,
        updateBackgroundActorSignedRelease,
        onboardingSteps,
        backgroundActors,
        backgroundActorsSignedReleasePercentage,
        loading,
        errors,
        warnings,
        readOnly,
        pristine
    } = props;

    useEffect(() => {
        fetchBackgroundActorOverview(filmId);

        return function cleanUp() {
            //clearCharacterOverview();
        };
    }, [filmId]);

    const onUpdateBackgroundActorSignedRelease = (actor, signed) => {
        if (readOnly) {
            return;
        }

        updateBackgroundActorSignedRelease(filmId, actor, signed);
    }

    function renderOverview(backgroundActors) {
        return (
            <ScrollIntoView
                className="blade-content wider"
                path="/films/:filmId/background-actors/overview"
                loading={loading}>
                <h2 className="menu-label">Background Actors Overview</h2>
                <Overview
                    backgroundActors={backgroundActors}
                    actorsSignedReleasePercentage={backgroundActorsSignedReleasePercentage}
                    filmId={filmId}
                    errors={errors}
                    warnings={warnings}
                    readOnly={readOnly}
                    onboardingSteps={onboardingSteps}
                    pristine={pristine}
                    updateBackgroundActorSignedRelease={onUpdateBackgroundActorSignedRelease} />
                <Onboarding onboardingSteps={onboardingSteps} section="Background Actors Overview" />
            </ScrollIntoView>
        );
    }

    return (
        <>
            {(loading || !backgroundActors) && <Loader />}
            {!loading && backgroundActors && renderOverview(backgroundActors)}
        </>
    );
};

function mapStateToProps(state) {
    const { errors, warnings, backgroundActors, backgroundActorsSignedReleasePercentage, loading, onboardingSteps, readOnly,
        pristine } =
        state.backgroundActorsOverviewState;
    return {
        errors,
        warnings,
        backgroundActors,
        loading,
        onboardingSteps,
        readOnly,
        pristine,
        backgroundActorsSignedReleasePercentage
    };
}

export default connect(mapStateToProps, {
    fetchBackgroundActorOverview,
    updateBackgroundActorSignedRelease
})(OverviewContainer);
